import React, { Component } from 'react';
import { Icon, Button } from 'antd';
import { utils } from '../../design_page/services';
import { mitt } from '../../services';
//图片广告提示
export class HotZoneTips extends Component<{
    items: Array<any>;
    onChange: (value: any) => void;
    bannerKey?: any;
}> {
    addItem = () => {
        const { items, onChange, bannerKey } = this.props;
        const cur = { uuid: utils.uuid() };
        mitt.emit(`hot-zone-create_${bannerKey}`, { arr: items, item: cur, onChange });
    };

    render() {
        return (
            <div
                className="entry-item item-create"
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Button type={'link'} onClick={this.addItem}>
                    <Icon type="plus" /> 添加热区
                </Button>
            </div>
        );
    }
}
